import styled from 'styled-components';

// Tela /dashboard/customer/plant — shell unico X/Twitter (mesmo padrao
// /reports, /dashboard, /customer): hairline borders, sem cards
// arredondados com sombra, sections separadas por borda discreta.
// Container: height fixa 100vh + overflow hidden trava o shell na
// viewport (sidebar de Favoritos+Historico scrolla independente).

// Container: a PAGINA inteira scrolla naturalmente quando conteudo
// passa do viewport. Antes tentamos height:100vh + overflow:hidden +
// scroll interno no LeftColumnGrid, mas o chain de min-height:0/flex
// no grid colapsava em alguns casos e o scroll nao engatava. Voltamos
// pra abordagem simples: min-height 100vh + sem overflow constraint
// — body scrolls quando passa.
export const NewContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: calc(100vw - 64px);
  min-height: 100vh;
  margin: 0 0 0 64px;
  padding: 0;
  box-sizing: border-box;
  background: var(--cco-bg);
  color: var(--cco-ink);

  @media (max-width: 720px) {
    width: 100vw;
    margin: 0;
  }
`;

// ============================================================
// HEADER BAR — breadcrumb (esq) + pin+nome (centro) + status (dir)
// Compartilha a divisao vertical do MainGrid abaixo.
// ============================================================
export const HeaderBar = styled.section`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  align-items: stretch;
  width: 100%;
  box-sizing: border-box;
  border-bottom: 1px solid var(--cco-line);
  min-height: 56px;

  @media (max-width: 1100px) {
    grid-template-columns: 1fr;
  }
`;

export const HeaderLeft = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  /* gap: garante respiro minimo entre breadcrumb e HeaderName mesmo
     quando o margin-left:auto do HeaderName colapsa em colunas
     apertadas. Sem isso, os 2 colavam. */
  gap: 14px;
  padding: 10px var(--cco-pad);
  border-right: 1px solid var(--cco-line);
  min-width: 0;

  @media (max-width: 1100px) {
    border-right: none;
    border-bottom: 1px solid var(--cco-line);
  }

  /* Em larguras estreitas o HeaderName quebra pra proxima linha
     (column) — gap muda pra vertical, breadcrumb em cima + nome
     embaixo, sem sobreposicao. */
  @media (max-width: 900px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
  }
`;

export const HeaderBreadcrumb = styled.div`
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  min-width: 0;
`;

// HeaderName sempre em FLUXO NORMAL (drop do position:absolute).
//
// O design original usava `position: absolute; left:50%; transform:
// translate(-50%,-50%)` pra centralizar o titulo geometricamente no
// HeaderLeft. Problema: quando o breadcrumb era comprido (ex.: com
// crumb "Ucha" no final), ele invadia o espaco do titulo absoluto
// e os dois SOBREPONHAM visualmente em qualquer largura.
//
// Solucao: titulo vira flex item irmao do breadcrumb, empurrado pra
// direita por margin-left:auto. Divider hairline (border-left +
// padding-left) sempre visivel. Em <=900px o pai vira column e o
// divider muda pra horizontal (border-top) sem sobreposicao.
export const HeaderName = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 15px;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: var(--cco-ink);
  white-space: nowrap;
  /* margin-left:auto empurra titulo pra direita do HeaderLeft. O
     gap:14px do pai (HeaderLeft) garante respiro minimo quando auto
     colapsa em viewports apertados. */
  margin-left: auto;
  border-left: 1px solid var(--cco-line-strong);
  padding-left: 14px;
  max-width: 60%;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;

  > span {
    overflow: hidden;
    text-overflow: ellipsis;
  }

  /* Mobile/tablet: HeaderLeft virou column, divider vira horizontal,
     titulo perde max-width e permite quebra de texto longo. */
  @media (max-width: 900px) {
    margin-left: 0;
    max-width: 100%;
    white-space: normal;
    word-break: break-word;
    border-left: 0;
    padding-left: 0;
    border-top: 1px solid var(--cco-line-strong);
    padding-top: 10px;
    width: 100%;
  }
`;

export const HeaderPin = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: ${(props) =>
    props.$accent === 'ucha'
      ? 'var(--cco-orange-soft)'
      : props.$accent === 'eba'
      ? 'var(--cco-blue-soft)'
      : 'var(--cco-blue-soft)'};
  color: ${(props) =>
    props.$accent === 'ucha' ? 'var(--cco-orange)' : 'var(--cco-blue)'};
  flex-shrink: 0;

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding: 10px var(--cco-pad);
  min-width: 0;
`;

// Botao "Parametros" no header (so role privilegiado) — abre o modal de
// cadastro de tarifa/placa. Estilo discreto (outline) pra nao competir com
// o status chip.
export const ParamsButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 7px;
  height: 32px;
  padding: 0 12px;
  border-radius: 8px;
  border: 1px solid var(--cco-line);
  background: transparent;
  color: var(--cco-ink-mute);
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  font-family: inherit;
  white-space: nowrap;
  transition: background 150ms, color 150ms, border-color 150ms;

  &:hover {
    background: var(--cco-soft-surface);
    color: var(--cco-ink);
    border-color: var(--cco-line-strong);
  }

  > svg {
    flex-shrink: 0;
  }

  @media (max-width: 640px) {
    > span {
      display: none;
    }
  }
`;

export const StatusChip = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 14px 6px 10px;
  border-radius: 999px;
  border: 1px solid ${(props) => props.$color || 'var(--cco-line)'};
  background: ${(props) =>
    props.$color ? `${props.$color}22` : 'transparent'};
  font-size: 11.5px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: ${(props) => props.$color || 'var(--cco-ink-mute)'};
  white-space: nowrap;
`;

export const StatusDot = styled.span`
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${(props) => props.$color || 'var(--cco-ink-mute)'};
  box-shadow: 0 0 0 3px
    ${(props) => (props.$color ? `${props.$color}33` : 'transparent')};
`;

// ============================================================
// MAIN GRID — Form 1fr | Sidebar 380px com hairline vertical
// (continua a divisao do HeaderBar).
// ============================================================
// Body: grid 2-col. Sem overflow constraint — quem rola e a pagina
// (Container nao tem overflow hidden). Cada coluna pega altura natural
// do seu conteudo.
export const NewContainerBody = styled.section`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  width: 100%;
  box-sizing: border-box;

  > * + * {
    border-left: 1px solid var(--cco-line);
  }

  @media (max-width: 1100px) {
    grid-template-columns: 1fr;
    > * + * {
      border-left: none;
      border-top: 1px solid var(--cco-line);
    }
  }
`;

// Coluna do form (esquerda): sections empilhadas com border-top hairline
// entre elas. Sem overflow — o body da pagina scrolla quando passa.
export const LeftColumnGrid = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  padding-bottom: 24px;
`;

// Coluna direita (sidebar de Favoritos + Historico).
// Sem overflow — flui junto com o body.
export const RightColumnGrid = styled.aside`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  background: var(--cco-bg);

  > * + * {
    border-top: 1px solid var(--cco-line);
  }
`;

export const HistoryPanel = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 0;
`;

export const HistoryTabs = styled.div`
  display: flex;
  align-items: center;
  gap: 18px;
  padding: 14px 22px 0;
`;

export const HistoryTab = styled.button`
  position: relative;
  padding: 6px 0 10px;
  border: 0;
  background: transparent;
  color: ${(props) =>
    props.$active ? props.theme.colors.darkerblue : props.theme.colors.label};
  font-family: inherit;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;

  &::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 2px;
    border-radius: 2px;
    background: ${(props) =>
      props.$active ? props.theme.colors.blue : 'transparent'};
  }

  &:hover {
    color: ${(props) => props.theme.colors.blue};
  }
`;

// ============================================================
// SECTION — padrao /reports: chip + content vertical, sem borda
// individual (a divisao vem do LeftColumnGrid via section+section).
// ============================================================
export const Section = styled.section`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
  padding: 22px var(--cco-pad);
  gap: 14px;
  background: transparent;
  border: none;
  border-radius: 0;
  box-shadow: none;
  min-height: 0;

  /* Hairline separando secoes consecutivas (padrao CCO). Declarada AQUI
     (e nao no pai via "> * + *") porque o border:none acima tem a mesma
     especificidade e, injetado depois, anulava a regra do pai — a linha
     nunca renderizava. "& + &" vem depois do reset e vence. */
  & + & {
    border-top: 1px solid var(--cco-line);
  }

  @media (max-width: 480px) {
    padding: 16px var(--cco-pad);
  }
`;

// Cabecalho da Section: chip + (opcional) descricao inline tipo SectionHead.
export const SectionHead = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`;

// SectionTag — pill soft-blue 999px com texto azul. Match exato do
// padrao /reports SectionTag (sem numero do step). Cor inline via
// prop $accent ('ucha' -> orange, 'eba' -> blue, default -> blue).
export const SectionTag = styled.div`
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 14px;
  border-radius: 999px;
  background: ${(props) =>
    props.$accent === 'ucha'
      ? 'var(--cco-orange-soft)'
      : 'var(--cco-blue-soft)'};
  color: ${(props) =>
    props.$accent === 'ucha' ? 'var(--cco-orange)' : 'var(--cco-blue)'};
  box-shadow: inset 0 0 0 1px
    ${(props) =>
      props.$accent === 'ucha'
        ? 'rgba(241, 162, 91, 0.25)'
        : 'rgba(78, 161, 243, 0.25)'};
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  flex-shrink: 0;
  pointer-events: none;
`;

// Wrapper do conteudo dentro de Section. Os sub-componentes
// (InformacoesAplicacao, EnergyHistoryChart, ConfigAplicacao,
// Velocimetro, LineChart) renderizam seu proprio conteudo aqui —
// SectionContent so cria o flex column + min-height 0 pra eles.
export const SectionContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 0;
  flex: 1;
`;

// Texto descritivo opcional ao lado do chip (match /reports SectionHint).
export const SectionHint = styled.p`
  margin: 0;
  font-size: 13.5px;
  font-weight: 500;
  color: var(--cco-ink-mute);
  line-height: 1.5;
  flex: 1;
  min-width: 200px;
`;

// ============================================================
// Abas dos blocos analiticos (Operacao / Analise / Financeiro /
// Por maquina). Agrupam as sections que antes empilhavam num scroll
// longo — so o grupo ativo renderiza. Visual = mesma familia do
// SectionTag (pill accent por tipo ucha/eba).
// ============================================================
export const AnalyticsTabs = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 8px;
  padding: 18px var(--cco-pad) 0;
`;

export const AnalyticsTab = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 7px;
  cursor: pointer;
  font-family: inherit;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  padding: 7px 14px;
  border-radius: 999px;
  transition: color 120ms, background 120ms, box-shadow 120ms;

  ${(props) =>
    props.$active
      ? `
        background: ${
          props.$accent === 'ucha'
            ? 'var(--cco-orange-soft)'
            : 'var(--cco-blue-soft)'
        };
        color: ${
          props.$accent === 'ucha' ? 'var(--cco-orange)' : 'var(--cco-blue)'
        };
        box-shadow: inset 0 0 0 1px ${
          props.$accent === 'ucha'
            ? 'rgba(241, 162, 91, 0.35)'
            : 'rgba(78, 161, 243, 0.35)'
        };
      `
      : `
        background: transparent;
        color: var(--cco-ink-faint);
        box-shadow: inset 0 0 0 1px var(--cco-line);
      `}

  svg {
    flex-shrink: 0;
  }

  &:hover {
    color: ${(props) =>
      props.$accent === 'ucha' ? 'var(--cco-orange)' : 'var(--cco-blue)'};
  }
`;

// ============================================================
// Compat — alguns lugares ainda referenciam Line/Column/Card.
// Mantidos como aliases minimos pra nao quebrar imports antigos.
// ============================================================
export const Line = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 16px;
`;

export const Column = styled(Line)`
  flex-direction: column;
`;

export const Card = styled.div`
  display: flex;
  flex: ${(props) => props.flex || 1};
  width: ${(props) => props.width || '100%'};
  box-sizing: border-box;
`;
